var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusSquare = function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 2.398a2.6 2.6 0 0 1 2.6 2.6v14a2.6 2.6 0 0 1-2.6 2.6H5a2.6 2.6 0 0 1-2.6-2.6v-14a2.6 2.6 0 0 1 2.6-2.6zm-14 1.2a1.4 1.4 0 0 0-1.4 1.4v14a1.4 1.4 0 0 0 1.4 1.4h14a1.4 1.4 0 0 0 1.4-1.4v-14a1.4 1.4 0 0 0-1.4-1.4zm7 3.9a.5.5 0 0 1 .5.5v3.5H16a.5.5 0 0 1 0 1h-3.5v3.5a.5.5 0 1 1-1 0v-3.5H8a.5.5 0 1 1 0-1h3.5v-3.5a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgPlusSquare;